import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'
import { X } from 'lucide-react'
import { styles } from '../../styles/themes/style'
import SvgFragment from '../SvgFragment'
import ActionText from '../../components/ActionText'
import { AppRoutes } from '../../interfaces/store/appStore'

interface IFilterDropdownButtonProps {
    svgType?: string
    icon?: ReactNode
    label?: string
    value?: ReactNode
    placeholder?: ReactNode
    selectValue?: string
    upgradePlan?: boolean
    active?: boolean
    resetFilter?: (e?: any) => void
}

const FilterDropdownButton: FunctionComponent<IFilterDropdownButtonProps> = ({ svgType, icon, label, value, placeholder, selectValue, upgradePlan, active, resetFilter }) => {
    return <Container>
                {icon ? <IconSlot>{icon}</IconSlot> : svgType ? <Icon><SvgFragment type={svgType}/></Icon> : null}
                {label ? (
                    <>
                        <LabelText>{label}:</LabelText>
                        <ValueText $active={active}>{upgradePlan ? (
                            <StyledActionText
                                icon="lock2"
                                onClickHandler={(e: any) => {
                                    e.stopPropagation();
                                    window.open(`${window.location.origin}${AppRoutes.BILLING}`, '_blank');
                                }}
                            >
                                {'Upgrade'}
                            </StyledActionText>
                        ) : (value ?? selectValue)}</ValueText>
                    </>
                ) : (
                    <FallbackText>{placeholder}</FallbackText>
                )}

                {!label && upgradePlan ? (
                    <StyledActionText
                        icon="lock2"
                        onClickHandler={(e: any) => {
                            e.stopPropagation();
                            window.open(`${window.location.origin}${AppRoutes.BILLING}`, '_blank');
                        }}
                    >
                        {'Upgrade'}
                    </StyledActionText>
                ) : null}

                {resetFilter && !upgradePlan && (
                    <ClearButton role="button" aria-label="Clear filter" onClick={(e) => { e.stopPropagation(); resetFilter(); }}>
                        <X size={14} strokeWidth={2} />
                    </ClearButton>
                )}
    </Container>
}

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
    height: 100%;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    background-color: transparent;
    font-size: 14px;
`
const Icon = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    color: ${styles.colors.black300};

    & svg,
    & .svg {
        width: 16px !important;
        height: 16px !important;
        max-width: 16px;
        max-height: 16px;
    }

    & path {
        fill: ${styles.colors.black300};
    }
`
const IconSlot = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    color: ${styles.colors.black300};

    & svg {
        width: 16px;
        height: 16px;
    }
`
const LabelText = styled.span`
    flex-shrink: 0;
    font-weight: 500;
    color: ${styles.colors.black600};
`
const ValueText = styled.span<{ $active?: boolean }>`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
    color: ${({ $active }) => ($active ? styles.colors.primary600 : styles.colors.black300)};
    font-weight: ${({ $active }) => ($active ? 600 : 400)};
`
/* stands alone in the trigger (no label next to it), so it reads as the field's
   value - keeping it grey made it look disabled */
const FallbackText = styled.span`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
    color: ${styles.colors.black600};
`
const ClearButton = styled.span`
    flex-shrink: 0;
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    cursor: pointer;
    color: ${styles.colors.black300};
    transition: color 0.15s ease;

    & svg {
        width: 14px;
        height: 14px;
    }

    &:hover { color: ${styles.colors.black500}; }
`
const StyledActionText = styled(ActionText)`
    flex-shrink: 0;
    span {    
        color: ${styles.colors.black300};
        font-size: 12px;
    }

    &:hover{
        path { fill: ${styles.colors.primary400} }
    }

    div {
        margin-right: 4px;
        svg {
            margin-bottom: 4px;
        }
    }
`

export default FilterDropdownButton
